import styled from 'styled-components';

import { getThemeProp } from 'theme';
import withUnit from 'utils/cssInJs/withUnit';

interface IProps {
  size?: number;
}

const Circle = styled.span`
  & {
    background-color: ${getThemeProp('colors.mercuryGrey')};
    border-radius: 50%;
    display: inline-block;

    ${({ size = 30 }: IProps) => `
     width: ${withUnit(size)}
     height: ${withUnit(size)}
  `}
  }
`;

export default Circle;
